import React, {Component, PropTypes} from 'react'
import {Row, Col, Panel, Input, Button, ButtonToolbar} from 'react-bootstrap'
import moment from 'moment'
import cx from 'classnames'
import distance from '../../core/distance'
import extract, {replace} from '../../core/extract'
import {linkFinder} from '../../core/links'
import {humanize} from '../../core/momentz'
import Icon from '../../core/components/Icon'
import StaticMap, {circlePath} from '../../core/components/StaticMap'
import config from '../../config'
import {WEEK_DAYS, InterventionPeriod} from '../models'
import i18n from '../i18n'
import DefineUpdateInterventionPeriodForActivityForm from './DefineUpdateInterventionPeriodForActivityForm'
import DefineRemoveInterventionZoneFromInterventionPeriodForm from './DefineRemoveInterventionZoneFromInterventionPeriodForm'
import DefineRemoveServiceChargeFromInterventionPeriodForm from './DefineRemoveServiceChargeFromInterventionPeriodForm'
import DefineRemoveCallOutChargesFromInterventionPeriodForm from './DefineRemoveCallOutChargesFromInterventionPeriodForm'
import SubscribeProviderCompanyToDirectoryForInterventionPeriodForm from './SubscribeProviderCompanyToDirectoryForInterventionPeriodForm'
import DefineRemoveRepairTimelimitFromInterventionPeriodForm from './DefineRemoveRepairTimelimitFromInterventionPeriodForm'
import DefineRemoveInterventionTimelimitFromInterventionPeriodForm from './DefineRemoveInterventionTimelimitFromInterventionPeriodForm'
import ExcludeOpeningTicketPurposesFromInterventionPeriodForm from './ExcludeOpeningTicketPurposesFromInterventionPeriodForm'
import style from './UpdateInterventionPeriodPanel.less'

function computeServiceCharge(interventionPeriod, referenceInterventionPeriod) {
    if (interventionPeriod.serviceCharge && interventionPeriod.serviceCharge.chargeType == 'ChargePercentage') {
        if (referenceInterventionPeriod && referenceInterventionPeriod.serviceCharge) {
            return {
                ...referenceInterventionPeriod.serviceCharge,
                value: Math.round(interventionPeriod.serviceCharge.value * referenceInterventionPeriod.serviceCharge.value * 100) / 100,
            }
        }

        console && console.log('interventionPeriod "' + interventionPeriod.uid + '" has a ChargePercentage serviceCharge with no reference defined')
        return null
    }
    return interventionPeriod.serviceCharge
}

function openingTicketPurposeFilter(openingTicketPurpose) {
    if (openingTicketPurpose) {
        return (openingTicketPurposeUid) => {
            return openingTicketPurposeUid == (openingTicketPurpose.uid || openingTicketPurpose)
        }
    }

    return (openingTicketPurposeUid) => {
        return true
    }
}

function openingTicketPurposeLabelAggregator(openingTicketPurposes) {
    return (result, openingTicketPurposeUid) => {
        const openingTicketPurpose = openingTicketPurposes.find((otp) => otp.uid == openingTicketPurposeUid)

        if (openingTicketPurpose) {
            result.push(openingTicketPurpose.label)
        }
        return result
    }
}

function timeLimitFilter(openingTicketPurpose) {
    if (openingTicketPurpose) {
        return (timelimit) => {
            return timelimit.openingTicketPurposes.find((openingTicketPurposeUid) => openingTicketPurposeUid == (openingTicketPurpose.uid || openingTicketPurpose))
        }
    }

    return (timelimit) => {
        return true
    }
}

function timelimitOpeningTicketPurposeAggregator(openingTicketPurposeReference) {
    return (result, timelimit) => {
        timelimit.openingTicketPurposes.forEach((openingTicketPurposeUid) => {
            const openingTicketPurpose = openingTicketPurposeReference.openingTicketPurposes.find((otp) => otp.uid == openingTicketPurposeUid)

            if (openingTicketPurpose) {
                result.push(openingTicketPurpose)
            } else {
                console && console.warn('openingTicketPurpose "' + openingTicketPurposeUid + '" doesn\'t exist in referentiel')
            }
        })
        return result
    }
}

function excludedOpeningTicketPurposeFilter(excludedIds) {
    return (openingTicketPurpose) => {
        return excludedIds.indexOf(openingTicketPurpose.uid) < 0
    }
}

function weekDaysFilter(weekDays) {
    return (weekDay) => {
        return weekDays.indexOf(weekDay) >= 0
    }
}

class UpdateInterventionPeriodPanel extends Component {
    static propTypes = {
        committed: PropTypes.object,
        activity: PropTypes.object,
        interventionPeriod: PropTypes.object.isRequired,
        referenceInterventionPeriod: PropTypes.object,
        incidentTypes: PropTypes.array,
        incidentType: PropTypes.any,
        openingTicketPurposeReference: PropTypes.object.isRequired,
        patrimony: PropTypes.object,
        onSubmit: PropTypes.func
    }

    constructor(props) {
        super(props)

        this.state = {
            repairOpeningTicketPurposes: [],
            interventionOpeningTicketPurposes: []
        }
    }

    componentWillMount() {
        const {expanded, interventionPeriod, referenceInterventionPeriod, incidentTypes, openingTicketPurposeReference} = this.props

        if (expanded) {
            const serviceCharge = computeServiceCharge(interventionPeriod, referenceInterventionPeriod)
            const includedOpeningTicketPurposes = incidentTypes && incidentTypes.filter(excludedOpeningTicketPurposeFilter(interventionPeriod.excludedOpeningTicketPurposes)) || []
            const onlyRepairOpeningTicketPurposes = interventionPeriod.repairTimelimits && interventionPeriod.repairTimelimits.reduce(timelimitOpeningTicketPurposeAggregator(openingTicketPurposeReference), []) || []
            const repairOpeningTicketPurposes = [...new Set([...includedOpeningTicketPurposes, ...onlyRepairOpeningTicketPurposes])]
            const onlyInterventionOpeningTicketPurposes = interventionPeriod.interventionTimelimits && interventionPeriod.interventionTimelimits.reduce(timelimitOpeningTicketPurposeAggregator(openingTicketPurposeReference), []) || []
            const interventionOpeningTicketPurposes = [...new Set([...includedOpeningTicketPurposes, ...onlyInterventionOpeningTicketPurposes])]
            this.setState({serviceCharge, repairOpeningTicketPurposes, interventionOpeningTicketPurposes})
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.expanded != this.props.expanded
            || nextProps.interventionPeriod != this.props.interventionPeriod
            || nextProps.referenceInterventionPeriod != this.props.referenceInterventionPeriod
            || nextProps.incidentTypes != this.props.incidentTypes
            || nextProps.openingTicketPurposeReference != this.props.openingTicketPurposeReference) {
            const {expanded, interventionPeriod, referenceInterventionPeriod, incidentTypes, openingTicketPurposeReference} = nextProps

            if (expanded) {
                const serviceCharge = computeServiceCharge(interventionPeriod, referenceInterventionPeriod)
                const includedOpeningTicketPurposes = incidentTypes && incidentTypes.filter(excludedOpeningTicketPurposeFilter(interventionPeriod.excludedOpeningTicketPurposes)) || []
                const onlyRepairOpeningTicketPurposes = interventionPeriod.repairTimelimits && interventionPeriod.repairTimelimits.reduce(timelimitOpeningTicketPurposeAggregator(openingTicketPurposeReference), []) || []
                const repairOpeningTicketPurposes = [...new Set([...includedOpeningTicketPurposes, ...onlyRepairOpeningTicketPurposes])]
                const onlyInterventionOpeningTicketPurposes = interventionPeriod.interventionTimelimits && interventionPeriod.interventionTimelimits.reduce(timelimitOpeningTicketPurposeAggregator(openingTicketPurposeReference), []) || []
                const interventionOpeningTicketPurposes = [...new Set([...includedOpeningTicketPurposes, ...onlyInterventionOpeningTicketPurposes])]
                this.setState({serviceCharge, repairOpeningTicketPurposes, interventionOpeningTicketPurposes})
            }
        }

        if (nextProps.expanded != this.props.expanded) {
            const {expanded} = nextProps
            
            if (!expanded) {
                this.setState({openedForm: null})
            }
        }
    }

    _isOpeningTicketPurposeExcluded(openingTicketPurpose) {
        const {interventionPeriod} = this.props
        return interventionPeriod.excludedOpeningTicketPurposes.indexOf(openingTicketPurpose.uid) >= 0
    }

    _toggleForm(name) {
        const {openedForm} = this.state

        const nextOpenedForm = openedForm != name && name || null
        this.setState({openedForm: nextOpenedForm})
    }

    _closeForm() {
        this.setState({openedForm: null})
    }

    render() {
        const {committed, activity, interventionPeriod, referenceInterventionPeriod, incidentTypes, incidentType, openingTicketPurposeReference, patrimony, bsStyle, onSelect, onSubmit, ...others} = this.props
        const {serviceCharge, repairOpeningTicketPurposes, interventionOpeningTicketPurposes, openedForm} = this.state

        const header = (
            <div className={style.header}>
                <h5 className={style.headerContent}>
                    <span>{interventionPeriod.period.label}</span>
                    {InterventionPeriod.isExpired(interventionPeriod) && (
                        <small> ({i18n.expired})</small>
                    )}
                </h5>
            </div>
        )

        const formatTimeSlot = (timeSlot) => {
            if (timeSlot.periods) {
                return timeSlot.periods.map((period) => {
                    return moment(period.start, 'HH:mm:ss').format(i18n.timeFormat.from) + ' ' + moment(period.end, 'HH:mm:ss').format(i18n.timeFormat.to)
                }).join(', ')
            }
            return i18n.timeSlotTypeEnum.allDayLong
        }

        const incidentTypeElement = (incidentType) => (
            <li
                key={incidentType.uid}
                className={cx({[style.excluded]: this._isOpeningTicketPurposeExcluded(incidentType)})}>
                <p>{incidentType.label}</p>
            </li>
        )

        return (
            <Panel
                header={header}
                bsStyle={interventionPeriod.reference && 'info' || 'default'}
                onSelect={onSelect}
                {...others}>
                <div className={style.defaultContent}>
                    <div>
                        <h5>
                            <span>{i18n.period}</span>
                            {committed && committed._links.find(linkFinder(['UpdateInterventionPeriodForActivity', 'UpdateInterventionPeriod'])) && (
                                <Button
                                    href=''
                                    bsStyle='link'
                                    onClick={() => this._toggleForm('DefineUpdateInterventionPeriodForActivityForm')}>
                                    <Icon icon='pencil' size='xs' />
                                </Button>
                            )}
                        </h5>
                        {openedForm != 'DefineUpdateInterventionPeriodForActivityForm' && (
                            <div>
                                {interventionPeriod.period.periodRanges && interventionPeriod.period.periodRanges.map((periodRange, index) => (
                                    <p key={index}>
                                        <span>{WEEK_DAYS.filter(weekDaysFilter(periodRange.weekDays)).map((wd) => moment.weekdays(WEEK_DAYS.indexOf(wd))).join(', ')}</span>
                                        <span> {formatTimeSlot(periodRange.timeSlot)}</span>
                                    </p>
                                ))}
                                {interventionPeriod.period.exclusions && interventionPeriod.period.exclusions.map((exclusion, index) => (
                                    <p key={index}>
                                        <span>sauf</span>
                                        <span> {exclusion.days.map((d) => moment(d).format(i18n.dateFormat.longer)).join(', ')}</span>
                                        <span> {formatTimeSlot(exclusion.timeSlot)}</span>
                                    </p>
                                ))}
                                {interventionPeriod.period.days && interventionPeriod.period.timeSlot && (
                                    <p>
                                        <span>{interventionPeriod.period.days.map((d) => moment(d).format(i18n.dateFormat.longer)).join(', ')}</span>
                                        <span> {formatTimeSlot(interventionPeriod.period.timeSlot)}</span>
                                    </p> 
                                )}
                                <p>
                                    <span>{interventionPeriod.period.startDate && moment(interventionPeriod.period.startDate).format(i18n.dateFormat.from)}</span>
                                    <span> {interventionPeriod.period.endDate && moment(interventionPeriod.period.endDate).format(i18n.dateFormat.to)}</span>
                                </p>
                            </div>
                        )}
                        {openedForm == 'DefineUpdateInterventionPeriodForActivityForm' && (
                            <DefineUpdateInterventionPeriodForActivityForm
                                committed={committed}
                                activity={activity}
                                interventionPeriod={interventionPeriod}
                                onSubmit={() => this._closeForm()} />
                        )}
                    </div>
                    <div className={style.interventionZone}>
                        <h5>
                            <span>{i18n.interventionZone}</span>
                            {committed && committed._links.find(linkFinder('DefineInterventionZoneForInterventionPeriod')) && (
                                <Button
                                    href=''
                                    bsStyle='link'
                                    onClick={() => this._toggleForm('DefineRemoveInterventionZoneFromInterventionPeriodForm')}>
                                    <Icon icon='pencil' size='xs' />
                                </Button>
                            )}
                        </h5>
                        {openedForm != 'DefineRemoveInterventionZoneFromInterventionPeriodForm' && interventionPeriod.interventionZone && (
                            <div className={style.container}>
                                <div className={style.map}>
                                    <StaticMap
                                        apiKey={config.google.apiKey}
                                        ratio={16/9}
                                        path={circlePath(interventionPeriod.interventionZone.address.geoLocation, interventionPeriod.interventionZone.range.value)}
                                        identify={(a) => a.geoLocation}
                                        value={patrimony && [...patrimony.addresses, ...patrimony.complementaryAddresses] || []} />
                                </div>
                                <div className={style.side}>
                                    <p>{interventionPeriod.interventionZone.address.quality}</p>
                                    <p>{interventionPeriod.interventionZone.address.number} {interventionPeriod.interventionZone.address.street}</p>
                                    <p>{interventionPeriod.interventionZone.address.zipCode} {interventionPeriod.interventionZone.address.city}</p>
                                    <p>distance : {distance(interventionPeriod.interventionZone.range.value).format('km')}</p>
                                </div>
                            </div>
                        )}
                        {committed && committed._links.find(linkFinder('DefineInterventionZoneForInterventionPeriod')) && openedForm == 'DefineRemoveInterventionZoneFromInterventionPeriodForm' && (
                            <DefineRemoveInterventionZoneFromInterventionPeriodForm
                                committed={committed}
                                activity={activity}
                                interventionPeriod={interventionPeriod}
                                onSubmit={() => this._closeForm()} />
                        )}
                    </div>
                    {(committed && committed._links.find(linkFinder('DefineServiceChargeForInterventionPeriod')) || serviceCharge) && (
                        <div>
                            <h5>
                                <span>{i18n.serviceCharge}</span>
                                {committed && committed._links.find(linkFinder('DefineServiceChargeForInterventionPeriod')) && (
                                    <Button
                                        href=''
                                        bsStyle='link'
                                        onClick={() => this._toggleForm('DefineRemoveServiceChargeFromInterventionPeriodForm')}>
                                        <Icon icon='pencil' size='xs' />
                                    </Button>
                                )}
                            </h5>
                            {openedForm != 'DefineRemoveServiceChargeFromInterventionPeriodForm' && serviceCharge && (
                                <p>
                                    <span>{serviceCharge.value} {extract(i18n.currencyEnum, serviceCharge.currency)}</span>
                                    {interventionPeriod.serviceCharge.chargeType == 'ChargePercentage' && (
                                        <span> ({replace(i18n.percentageServiceChargeInfo, {percentage: interventionPeriod.serviceCharge.value * 100})})</span>
                                    )}
                                </p>
                            )}
                            {committed && committed._links.find(linkFinder('DefineServiceChargeForInterventionPeriod')) && openedForm == 'DefineRemoveServiceChargeFromInterventionPeriodForm' && (
                                <DefineRemoveServiceChargeFromInterventionPeriodForm
                                    activity={activity}
                                    interventionPeriod={interventionPeriod}
                                    onSubmit={() => this._closeForm()} />
                            )}
                        </div>
                    )}
                    {(committed && committed._links.find(linkFinder('DefineCallOutChargesForInterventionPeriod')) || interventionPeriod.callOutCharges) && (
                        <div>
                            <h5>
                                <span>{i18n.callOutCharge}</span>
                                {committed && committed._links.find(linkFinder('DefineCallOutChargesForInterventionPeriod')) && (
                                    <Button
                                        href=''
                                        bsStyle='link'
                                        onClick={() => this._toggleForm('DefineRemoveCallOutChargesFromInterventionPeriodForm')}>
                                        <Icon icon='pencil' size='xs' />
                                    </Button>
                                )}
                            </h5>
                            {openedForm != 'DefineRemoveCallOutChargesFromInterventionPeriodForm' && interventionPeriod.callOutCharges.map((callOutCharge, index) => (
                                <p
                                    key={index}>
                                    <span>{replace(i18n.distanceFromTo, {from: distance(callOutCharge.range.start).format('km'), to: distance(callOutCharge.range.end).format('km')})}</span>
                                    <span> : {callOutCharge.charge.value} {extract(i18n.currencyEnum, callOutCharge.charge.currency)}</span>
                                </p>
                            ))}
                            {committed && committed._links.find(linkFinder('DefineCallOutChargesForInterventionPeriod')) && openedForm == 'DefineRemoveCallOutChargesFromInterventionPeriodForm' && (
                                <DefineRemoveCallOutChargesFromInterventionPeriodForm
                                    activity={activity}
                                    interventionPeriod={interventionPeriod}
                                    onSubmit={() => this._closeForm()} />
                            )}
                        </div>
                    )}
                    {(committed && committed._links.find(linkFinder('SubscribeProviderCompanyToDirectoryForInterventionPeriod')) || interventionPeriod.subscriptions) && (
                        <div>
                            <h5>
                                <span>{i18n.subscription}</span>
                                {committed && committed._links.find(linkFinder('SubscribeProviderCompanyToDirectoryForInterventionPeriod')) && (
                                    <Button
                                        href=''
                                        bsStyle='link'
                                        onClick={() => this._toggleForm('SubscribeProviderCompanyToDirectoryForInterventionPeriodForm')}>
                                        <Icon icon='pencil' size='xs' />
                                    </Button>
                                )}
                            </h5>
                            {openedForm != 'SubscribeProviderCompanyToDirectoryForInterventionPeriodForm' && interventionPeriod.subscriptions.map((subscription, index) => (
                                <p
                                    key={index}>
                                    <span>{extract(i18n.forWhoEnum, subscription.forWho)} :</span>
                                    <span> {subscription.forWhat.map((w) => extract(i18n.forWhatEnum, w)).join(', ')}</span>
                                </p>
                            ))}
                            {committed && committed._links.find(linkFinder('SubscribeProviderCompanyToDirectoryForInterventionPeriod')) && openedForm == 'SubscribeProviderCompanyToDirectoryForInterventionPeriodForm' && (
                                <SubscribeProviderCompanyToDirectoryForInterventionPeriodForm
                                    activity={activity}
                                    interventionPeriod={interventionPeriod}
                                    onSubmit={() => this._closeForm()} />
                            )}
                        </div>
                    )}
                    {(committed && committed._links.find(linkFinder('DefineRepairTimelimitForInterventionPeriod')) || interventionPeriod.repairTimelimits) && (
                        <div>
                            <h5>
                                <span>{i18n.repairTimelimit}</span>
                                {committed && committed._links.find(linkFinder('DefineRepairTimelimitForInterventionPeriod')) && (
                                    <Button
                                        href=''
                                        bsStyle='link'
                                        onClick={() => this._toggleForm('DefineRemoveRepairTimelimitFromInterventionPeriodForm')}>
                                        <Icon icon='pencil' size='xs' />
                                    </Button>
                                )}
                            </h5>
                            {openedForm != 'DefineRemoveRepairTimelimitFromInterventionPeriodForm' && interventionPeriod.repairTimelimits.filter(timeLimitFilter(incidentType)).map((repairTimelimit, index) => (
                                <p
                                    key={index}>
                                    <span>{repairTimelimit.openingTicketPurposes.filter(openingTicketPurposeFilter(incidentType)).reduce(openingTicketPurposeLabelAggregator(repairOpeningTicketPurposes), []).join(', ')} :</span>
                                    <span> {humanize(moment.duration(repairTimelimit.timelimit.value))}</span>
                                </p>
                            ))}
                            {committed && committed._links.find(linkFinder('DefineRepairTimelimitForInterventionPeriod')) && openedForm == 'DefineRemoveRepairTimelimitFromInterventionPeriodForm' && (
                                <DefineRemoveRepairTimelimitFromInterventionPeriodForm
                                    interventionPeriod={interventionPeriod}
                                    openingTicketPurposes={repairOpeningTicketPurposes}
                                    onSubmit={() => this._closeForm()} />
                            )}
                        </div>
                    )}
                    {(committed && committed._links.find(linkFinder('DefineInterventionTimelimitForInterventionPeriod')) || interventionPeriod.interventionTimelimits) && (
                        <div>
                            <h5>
                                <span>{i18n.interventionTimelimit}</span>
                                {committed && committed._links.find(linkFinder('DefineInterventionTimelimitForInterventionPeriod')) && (
                                    <Button
                                        href=''
                                        bsStyle='link'
                                        onClick={() => this._toggleForm('DefineRemoveInterventionTimelimitFromInterventionPeriodForm')}>
                                        <Icon icon='pencil' size='xs' />
                                    </Button>
                                )}
                            </h5>
                            {openedForm != 'DefineRemoveInterventionTimelimitFromInterventionPeriodForm' && interventionPeriod.interventionTimelimits.filter(timeLimitFilter(incidentType)).map((interventionTimelimit, index) => (
                                <p
                                    key={index}>
                                    <span>{interventionTimelimit.openingTicketPurposes.filter(openingTicketPurposeFilter(incidentType)).reduce(openingTicketPurposeLabelAggregator(interventionOpeningTicketPurposes), []).join(', ')} :</span>
                                    <span> {humanize(moment.duration(interventionTimelimit.timelimit.value))}</span>
                                </p>
                            ))}
                            {committed && committed._links.find(linkFinder('DefineInterventionTimelimitForInterventionPeriod')) && openedForm == 'DefineRemoveInterventionTimelimitFromInterventionPeriodForm' && (
                                <DefineRemoveInterventionTimelimitFromInterventionPeriodForm
                                    interventionPeriod={interventionPeriod}
                                    openingTicketPurposes={interventionOpeningTicketPurposes}
                                    onSubmit={() => this._closeForm()} />
                            )}
                        </div>
                    )}
                    {(committed && committed._links.find(linkFinder('ExcludeOpeningTicketPurposesFromInterventionPeriod')) || interventionPeriod.excludedOpeningTicketPurposes) && incidentTypes && (
                        <div className={style.openingTicketPurposes}>
                            <h5>
                                <span>{i18n.openingTicketPurposes}</span>
                                {committed && committed._links.find(linkFinder('ExcludeOpeningTicketPurposesFromInterventionPeriod')) && (
                                    <Button
                                        href=''
                                        bsStyle='link'
                                        onClick={() => this._toggleForm('ExcludeOpeningTicketPurposesFromInterventionPeriodForm')}>
                                        <Icon icon='pencil' size='xs' />
                                    </Button>
                                )}
                            </h5>
                            {openedForm != 'ExcludeOpeningTicketPurposesFromInterventionPeriodForm' && (
                                <Row>
                                    <Col sm={6}>
                                        <ul>
                                            {incidentTypes.slice(0, incidentTypes.length / 2 + 1).map(incidentTypeElement)}
                                        </ul>
                                    </Col>
                                    <Col sm={6}>
                                        <ul>
                                            {incidentTypes.slice(incidentTypes.length / 2 + 1, incidentTypes.length).map(incidentTypeElement)}
                                        </ul>
                                    </Col>
                                </Row>
                            )}
                            {committed && committed._links.find(linkFinder('ExcludeOpeningTicketPurposesFromInterventionPeriod')) && openedForm == 'ExcludeOpeningTicketPurposesFromInterventionPeriodForm' && (
                                <ExcludeOpeningTicketPurposesFromInterventionPeriodForm
                                    interventionPeriod={interventionPeriod}
                                    openingTicketPurposes={incidentTypes}
                                    onSubmit={() => this._closeForm()} />
                            )}
                        </div>
                    )}
                    {committed && committed._links.find(linkFinder('RemoveInterventionPeriod')) && (
                        <div className={style.delete}>
                            <a
                                href=''
                                onClick={(e) => onSubmit(e, 'RemoveInterventionPeriod', interventionPeriod)}>
                                {i18n.removeInterventionPeriod} ...
                            </a>
                        </div>
                    )}
                </div>
            </Panel>
        )
    }
}

export default UpdateInterventionPeriodPanel


// WEBPACK FOOTER //
// ./lib/provider/components/UpdateInterventionPeriodPanel.js